"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationInsightsModule = void 0;
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var app_insight_service_1 = require("./src/app-insight.service");
var app_insight_service_2 = require("./src/app-insight.service");
Object.defineProperty(exports, "SeverityLevel", { enumerable: true, get: function () { return app_insight_service_2.SeverityLevel; } });
Object.defineProperty(exports, "AppInsightsConfig", { enumerable: true, get: function () { return app_insight_service_2.AppInsightsConfig; } });
Object.defineProperty(exports, "AppInsightsService", { enumerable: true, get: function () { return app_insight_service_2.AppInsightsService; } });
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common');
var ApplicationInsightsModule = /** @class */ (function () {
    function ApplicationInsightsModule(parentModule, appInsightsService) {
        if (!parentModule) {
            appInsightsService.init();
        }
    }
    ApplicationInsightsModule.forRoot = function (config) {
        return {
            ngModule: ApplicationInsightsModule,
            providers: [
                { provide: app_insight_service_1.AppInsightsConfig, useValue: config },
                app_insight_service_1.AppInsightsService
            ]
        };
    };
    ApplicationInsightsModule.ctorParameters = function () { return [
        { type: ApplicationInsightsModule, decorators: [{ type: core_1.Optional }, { type: core_1.SkipSelf }] },
        { type: app_insight_service_1.AppInsightsService }
    ]; };
ApplicationInsightsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ApplicationInsightsModule });
ApplicationInsightsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ApplicationInsightsModule_Factory(t) { return new (t || ApplicationInsightsModule)(ɵngcc0.ɵɵinject(ApplicationInsightsModule, 12), ɵngcc0.ɵɵinject(app_insight_service_1.AppInsightsService)); }, providers: [app_insight_service_1.AppInsightsService], imports: [[common_1.CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ApplicationInsightsModule, { imports: [ɵngcc1.CommonModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApplicationInsightsModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [common_1.CommonModule],
                declarations: [],
                exports: [],
                providers: [app_insight_service_1.AppInsightsService]
            }]
    }], function () { return [{ type: ApplicationInsightsModule, decorators: [{
                type: core_1.Optional
            }, {
                type: core_1.SkipSelf
            }] }, { type: app_insight_service_1.AppInsightsService }]; }, null); })();
    return ApplicationInsightsModule;
}());
exports.ApplicationInsightsModule = ApplicationInsightsModule;

//# sourceMappingURL=index.js.map